import { Link } from "react-router-dom";
import { ArrowLeft, HardHat } from "lucide-react";
import { usePageTitle } from "../hooks/usePageTitle";

export default function NotFound() {
  usePageTitle("Page Not Found");
  return (
    <div className="pt-20 md:pt-24" data-testid="not-found-page">
      <section className="bg-[#2C3539] text-white min-h-[70vh] flex items-center">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-16 py-24">
          <HardHat size={48} className="text-[#9CC4DB]" />
          <div className="mt-6 text-[#9CC4DB] text-xs tracking-[0.35em] font-bold uppercase">Error 404</div>
          <h1 className="mt-3 font-display text-6xl md:text-8xl uppercase leading-[0.92]">This lot is<br />still vacant.</h1>
          <p className="mt-6 max-w-xl text-white/80 text-base md:text-lg">
            The page you're looking for doesn't exist — it may have been moved, or the address was typed wrong.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/" data-testid="notfound-home-btn" className="inline-flex items-center gap-2 bg-[#2F5F80] hover:bg-[#234B66] text-white text-sm font-bold tracking-[0.15em] px-7 py-3.5 uppercase transition-colors">
              <ArrowLeft size={16} /> Back to Home
            </Link>
            <Link to="/contact" data-testid="notfound-contact-btn" className="inline-flex items-center gap-2 border-2 border-white/30 hover:border-[#9CC4DB] hover:text-[#9CC4DB] text-white text-sm font-bold tracking-[0.15em] px-7 py-3 uppercase transition-colors">
              Get a Quote
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
